<template>
  <div>
    <div class="md-layout md-gutter">
      <div class="md-layout-item md-size-100">
        <h4 v-if="!form || !form.id || form.id == 0">{{$t('new-address')}}</h4>
        <h4 v-else>{{$t('update-address')}}</h4>
      </div>
      <div class="md-layout-item md-size-100">
        <form novalidate @submit.prevent="validateForm" autocomplete="off">
          <div class="md-layout md-gutter">
            <div class="md-layout-item" :class="'md-size-'+item.size" v-for="item in config" v-bind:key="item.id">
              <md-field :class="getValidationClass(item.model)" v-if="item.type=='input'">
                <label :for="item.id">{{item.label}}</label>
                <md-input :name="item.id" :id="item.id" v-model="form[item.model]" :disabled="sending" />
                <span v-for="(value, name, index) in $v.form[item.model]" v-bind:key="index">
                  <span class="md-error" v-if="name.indexOf('$')==-1 && !value">{{item.errorMsg[index]}}</span>
                </span>
              </md-field>

              <div v-if="item.type=='text'">
                <label>{{item.label}}</label>
                <div style="line-height:20px;font-weight:400; padding-top:10px;">{{form[item.model]}}</div>
              </div>

              <md-field :class="getValidationClass(item.model)" v-if="item.type=='select'">
                <label>{{item.label}}</label>
                <md-select v-model="form[item.model]" :name="item.id" :id="item.id" md-dense :disabled="sending">
                  <md-option :value="i.id" v-for="i in item.list" v-bind:key="i.id">{{i.name}}</md-option>
                </md-select>
                <span v-for="(value, name, index) in $v.form[item.model]" v-bind:key="index">
                  <span class="md-error" v-if="name.indexOf('$')==-1 && !value">{{item.errorMsg[index]}}</span>
                </span>
              </md-field>

            </div>
          </div>
          <div class="md-layout">
            <div class="md-layout-item text-right">
              <md-button type="button" class="md-accent" v-on:click="$emit('cancel')" v-if="addressList&&addressList.length > 0">{{$t('cancel')}}</md-button>
              <md-button type="button" class="md-accent" v-on:click="$emit('back')" v-if="!addressList || addressList.length == 0">{{$t('back')}}</md-button>
              <md-button type="submit" class="md-raised md-primary" v-on:click="submit(form)" :disabled="loading">
                {{$t('submit')}} <md-progress-spinner class="md-primary" md-mode="indeterminate" :md-value="80" :md-diameter="14" :md-stroke="2" v-if="loading"></md-progress-spinner>
              </md-button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import { validationMixin } from 'vuelidate'
  //   import {
  //     required
  //   } from 'vuelidate/lib/validators'
  import addressConfig from '../mixins/address'

  export default {
    name: 'AddressForm',
    mixins: [validationMixin],
    props: {
      cancel: Function,
      addressData: Object,
      addressList: Array
    },
    data: () => ({
      form: {
        firstName: null,
        lastName: null,
        mobile1: null,
        mobile2: null,
        address1: null,
        address2: null,
        city: null,
        state: null,
        postalCode: null,
        vatNumber: null,
        district: null
      },
      sending: false,
      loading: false,
      config: []
    }),
    created() {
      window.console.log(this.$v.form)
      this.loading = false
      this.form = { ...this.addressData }

      if (this.addressData != null && this.addressData.countryCode.length > 0 && addressConfig[this.addressData.countryCode])
        this.config = addressConfig[this.addressData.countryCode]
      else this.config = addressConfig['config']
      
    },
    validations() {
      let form = {}
      for (const i in this.config) {
        const item = this.config[i]
        if (item.validation) form[item.model] = item.validation
      }
      return { form: form }
    },
    methods: {
      getValidationClass(fieldName) {
        const field = this.$v.form[fieldName]
        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          }
        }
      },
      clearForm() {

      },
      saveUser() {

      },
      validateForm() {
        this.$v.$touch()
      },
      submit(item) {
        this.$v.$touch()
        if (!this.$v.$invalid) {
          this.loading = true
          this.$emit('submit', item)
          setTimeout(() => {
            this.loading = false
          }, 1000*10)
        }
      }
    }
  }
</script>


<style lang="scss" scoped>

  @import "~vue-material/dist/theme/engine";
</style>

